import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/evaluation/criteria-item');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions(
  'evaluation-item',
  validationApi,
);

export function getEvaluationItemValidationHistoryOptions(evaluationItemId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(evaluationItemId);
}

export function getEvaluationItemValidationOptions(evaluationItemId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(evaluationItemId);
}

export function useValidateEvaluationItem(evaluationItemId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(evaluationItemId, queryClient));
}
